'use strict';

var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
var classNames = require('classnames');
var withStyles = require('../../Styles/withStyles.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var CardButton = require('./CardButton.js');
var Grid = require('../../Layout/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var styles = function styles(theme) {
  return {
    cardButton: {
      padding: 0,
      borderRadius: 9,
      border: "1px solid ".concat(theme.palette.divider),
      textTransform: 'none',
      overflow: 'hidden !important',
      textAlign: 'left',
      maxWidth: 250
    },
    cardNotPresent: {
      opacity: '0.3'
    },
    body: {
      padding: 16,
      borderRadius: '8px 8px 0px 0px'
    },
    footerContainer: {
      padding: 16,
      borderRadius: '0px 0px 8px 8px',
      backgroundColor: theme.palette.brandPrimary.light,
      minHeight: 48
    },
    showAddIcon: {
      visibility: 'visible',
      opacity: 1,
      color: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.primary.main
      }
    },
    showCancelIcon: {
      visibility: 'visible',
      opacity: 1,
      color: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.error.main
      }
    },
    hideIcon: {
      visibility: 'hidden'
    },
    title: {
      height: 24
    }
  };
};

var CardButtonWithFooter = function CardButtonWithFooter(_ref) {
  var title = _ref.title,
      footer = _ref.footer,
      children = _ref.children,
      isPresent = _ref.isPresent,
      onClick = _ref.onClick,
      action = _ref.action,
      disableRipple = _ref.disableRipple,
      classes = _ref.classes;

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      hovered = _useState2[0],
      setHovered = _useState2[1];

  var opacityClass = isPresent || hovered ? '' : classes.cardNotPresent;
  var showIcon = isPresent ? classes.showCancelIcon : classes.showAddIcon;
  var iconClass = !hovered ? classes.hideIcon : showIcon;

  var header = function header() {
    if (action !== null) {
      return React__default["default"].createElement(Grid, {
        container: true,
        justify: "space-between",
        className: classes.title
      }, React__default["default"].createElement(Grid, {
        item: true,
        xs: 11,
        className: opacityClass
      }, React__default["default"].createElement(Typography, {
        variant: "body1",
        color: "textPrimary",
        noWrap: true
      }, title)), React__default["default"].createElement(Grid, {
        item: true,
        xs: 1,
        className: iconClass,
        onClick: function onClick() {
          return setHovered(false);
        }
      }, action));
    }

    return React__default["default"].createElement(Grid, {
      container: true,
      justify: "space-between",
      className: classes.title
    }, React__default["default"].createElement(Grid, {
      item: true,
      xs: 12,
      className: opacityClass
    }, React__default["default"].createElement(Typography, {
      variant: "body1",
      color: "textPrimary",
      noWrap: true
    }, title)));
  };

  return React__default["default"].createElement(CardButton, {
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    },
    className: classes.cardButton,
    onClick: onClick,
    disableRipple: disableRipple
  }, React__default["default"].createElement(Grid, {
    container: true
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classes.body
  }, header(), React__default["default"].createElement("div", {
    className: opacityClass
  }, children)), React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    className: classNames__default["default"](classes.footerContainer, opacityClass)
  }, React__default["default"].createElement(Typography, {
    variant: "caption",
    color: "textPrimary",
    noWrap: true
  }, footer))));
};

CardButtonWithFooter.defaultProps = {
  action: null,
  onClick: function onClick() {},
  disableRipple: false
};
var CardButtonWithFooter$1 = withStyles["default"](styles)(CardButtonWithFooter);

module.exports = CardButtonWithFooter$1;
